import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';

import Brand from 'models/brand';

import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';

const propTypes = {
  brand: PropTypes.instanceOf(Brand),
  app: PropTypes.string,
  trackEvent: PropTypes.func,
};

const defaultProps = {
  brand: new Brand(),
  app: '',
  trackEvent: () => {},
};

class TransferPassButton extends Component {
  constructor(props) {
    super(props);

    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onVisibilityChange(isVisible) {
    const { trackEvent, app } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({ app });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'TransferPass',
        position: '0',
      });
    }
  }

  onClick() {
    const { trackEvent, app } = this.props;
    const pageProperties = pageProps({ app });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'TransferPass',
      position: '0',
    });
  }

  render() {
    const { brand } = this.props;
    const buttonClasses = cx({
      'btn-alternate': true,
      'btn': true,
      'btn-bp': brand.isBestParking,
    });

    return (
      <VisibilitySensor onChange={this.onVisibilityChange} partialVisibility>
        <div>
          <div className="transfer-pass hidden-lte-sm">
            <a href="/account/transfer-pass" target="_blank" className={buttonClasses} onClick={this.onClick}>
              Transfer A Pass
            </a>
          </div>
          <div className="transfer-pass visible-lte-sm">
            <a href="/account/transfer-pass" target="_blank" onClick={this.onClick}>
              TRANSFER A PASS
            </a>
          </div>
        </div>
      </VisibilitySensor>

    );
  }
}

TransferPassButton.propTypes = propTypes;
TransferPassButton.defaultProps = defaultProps;

export default TransferPassButton;
